import { IFilterEmployeeRequestType, ILeaveBalanceRequestType, ILeavesContractRequestType, IOTContractRequestType } from "./type"

const reportsUrl = "/reports"
export const ReportsUrlConst = {
    // overtimeEmployeesUrl: `${reportsUrl}/overtime/filter/employees`,
    overtimeUrl: `${reportsUrl}/overtime`,
    overtimeProjectUrl: `${reportsUrl}/overtime/projectwise`,
    leavesMonthlySummaryUrl: `${reportsUrl}/leaves/monthly-summary`,
    leavesEmployeeWiseUrl: `${reportsUrl}/leaves/employee-wise`,
    // leavesEmployeesUrl: `${reportsUrl}/leaves/filter/employees`,
    leavesYearUrl: `${reportsUrl}/leaves/filter/years`,
    leavesMonthsUrl: `${reportsUrl}/leaves/filter/months`,
    leavesDetailedReportUrl: `${reportsUrl}/leaves/detailed-report`,
    internshipReportUrl: `${reportsUrl}/internship`,
    overtimeDetailstUrl: `${reportsUrl}/overtime/overtimedetails`,
    attendanceReportUrl: `${reportsUrl}/attendance`

}

export const overtimeContractUrl = (params: IOTContractRequestType) => {
    return `${reportsUrl}/overtime/filter/employee/contract/${params.employeeId}`
}
export const leavesContractUrl = (params: ILeavesContractRequestType) => {
    return `${reportsUrl}/leaves/filter/employee/contract/${params.employeeContractId}`
}
export const leavesBalanceUrl = (params: ILeaveBalanceRequestType) => {
    return `${reportsUrl}/leaves/balance/${params.contractId}`
}
export const filterEmployeeUrl = (params: IFilterEmployeeRequestType) => {
    return `${reportsUrl}/filterEmployees/${params.recordStatus}`
}